import {Map} from 'immutable';

import * as BetGamesActions from '../../actions/betGames/index';
import * as AuthAction from '../../actions/auth/SignoutAction.js';

const initialState = Map({
    token: undefined,
    fetching: false
});

export default function join(state = initialState, action = {}) {
    switch (action.type) {
        case BetGamesActions.FETCH_BETGAMES_TOKEN:
            return state.set('fetching', true);
        case BetGamesActions.SUCCESS_FETCH_BETGAMES_TOKEN:
            state = state.set('fetching', false);
            if (typeof action.data === 'string') {
                return state.set('token', action.data);
            } else {
                return state.set('token', undefined);
            }

        case BetGamesActions.FAILURE_FETCH_BETGAMES_TOKEN:
            return state.set('fetching', false);

        case AuthAction.SUCCESS_SIGNOUT:
            return state.set('token', undefined);
    }

    return state;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/betGamesReducer.js